import { __fireOnAuth } from './events'

export function setAuthToken(token?: string, expiresAt?: number) {
  localStorage.setItem("token", token || '');
  localStorage.setItem("tokenExpiresAt", (expiresAt || '').toString());
  propagateAuthToken();
}

export function clearAuthToken() {
  localStorage.removeItem("token");
  localStorage.removeItem("tokenExpiresAt");
  propagateAuthToken();
}

export function isAuthenticated() {
  if (!localStorage.token) return false;
  if (!localStorage.tokenExpiresAt) return true;
  return parseInt(localStorage.tokenExpiresAt) > Date.now();
}

let expireTokenTimer: number | null = null;

export function propagateAuthToken() {
  const isAuth = isAuthenticated();
  const token = isAuth ? localStorage.token : undefined;
  const tokenExpiresAt =
    isAuth && localStorage.tokenExpiresAt
      ? parseInt(localStorage.tokenExpiresAt)
      : undefined;
  __fireOnAuth(isAuth, { token, tokenExpiresAt });

  if (expireTokenTimer) window.clearTimeout(expireTokenTimer);

  if (!!token && !!tokenExpiresAt) {
    expireTokenTimer = window.setTimeout(
      propagateAuthToken,
      tokenExpiresAt - Date.now()
    );
  }
}